<template>
  <div class="main-content">
    <!-- 页面标题 -->
    <div class="title">{{ $t('giftCardPurchase.title') }}</div>

    <!-- 步骤1：查询用户 -->
    <div class="search-box">
      <h4>{{ $t('giftCardPurchase.step1') }}</h4>
      <el-form :inline="true" :model="userSearchForm">
        <el-form-item :label="$t('giftCardPurchase.userAccount')">
          <el-input v-model="userSearchForm.zhanghao" :placeholder="$t('giftCardPurchase.inputUserAccount')" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchUser">{{ $t('giftCardPurchase.searchUser') }}</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 用户信息展示 -->
    <div v-if="userData" class="user-info-section">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>{{ $t('giftCardPurchase.selectedUser') }}</span>
        </div>
        <div class="user-content">
          <div class="info-item">
            <span class="label">{{ $t('giftCardPurchase.account') }}：</span>
            <span class="value">{{ userData.zhanghao }}</span>
          </div>
          <div class="info-item" v-if="userData.xingming">
            <span class="label">{{ $t('giftCardPurchase.name') }}：</span>
            <span class="value">{{ userData.xingming }}</span>
          </div>
          <div class="info-item" v-if="userData.yue !== undefined">
            <span class="label">{{ $t('giftCardPurchase.balance') }}：</span>
            <span class="value">{{ userData.yue }} {{ $t('common.yuan') }}</span>
          </div>
        </div>
      </el-card>
    </div>

    <!-- 步骤2：查询礼品卡 -->
    <div class="search-box" v-if="userData">
      <h4>{{ $t('giftCardPurchase.step2') }}</h4>
      <el-form :inline="true" :model="searchForm">
        <el-form-item :label="$t('giftCard.cardNo')">
          <el-input v-model="searchForm.cardNo" :placeholder="$t('giftCard.inputCardNo')" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchCard">{{ $t('common.search') }}</el-button>
          <el-button @click="resetSearch">{{ $t('common.reset') }}</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 卡片信息 -->
    <div v-if="cardInfo" class="card-info">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>{{ $t('giftCardPurchase.cardInfo') }}</span>
        </div>
        <div class="card-content">
          <div class="info-item">
            <span class="label">{{ $t('giftCard.cardNo') }}：</span>
            <span class="value">{{ cardInfo.cardNo }}</span>
          </div>
          <div class="info-item">
            <span class="label">{{ $t('giftCard.amount') }}：</span>
            <span class="value">¥{{ cardInfo.amount }}</span>
          </div>
          <div class="info-item">
            <span class="label">{{ $t('giftCardPurchase.validUntil') }}：</span>
            <span class="value">{{ cardInfo.expireTime }}</span>
          </div>
          <div class="info-item">
            <span class="label">{{ $t('common.status') }}：</span>
            <el-tag :type="cardInfo.status === 0 ? 'success' : cardInfo.status === 1 ? 'info' : 'danger'">
              {{ cardInfo.status === 0 ? $t('giftCard.unused') : cardInfo.status === 1 ? $t('giftCard.used') : $t('giftCard.expired') }}
            </el-tag>
          </div>
        </div>
        <div class="card-footer" v-if="cardInfo.status === 0">
          <el-button type="primary" @click="showPurchaseDialog">{{ $t('giftCardPurchase.purchase') }}</el-button>
        </div>
      </el-card>
    </div>

    <!-- 购买对话框 -->
    <el-dialog :title="$t('giftCardPurchase.purchaseGiftCard')" :visible.sync="purchaseDialogVisible" width="500px">
      <el-form :model="purchaseForm" :rules="purchaseRules" ref="purchaseForm" label-width="100px">
        <el-form-item :label="$t('giftCardPurchase.paymentMethod')" prop="paymentMethod">
          <el-select v-model="purchaseForm.paymentMethod" :placeholder="$t('giftCardPurchase.selectPaymentMethod')">
            <el-option :label="$t('giftCardPurchase.wechatPay')" value="wechat"></el-option>
            <el-option :label="$t('giftCardPurchase.alipay')" value="alipay"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('giftCardPurchase.paymentAmount')">
          <span>¥{{ cardInfo ? cardInfo.amount : 0 }}</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="purchaseDialogVisible = false">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary" @click="purchaseCard">{{ $t('common.confirm') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      searchForm: {
        cardNo: ''
      },
      cardInfo: null,
      purchaseDialogVisible: false,
      purchaseForm: {
        paymentMethod: ''
      },
      purchaseRules: {
        paymentMethod: [{ required: true, message: this.$t('giftCardPurchase.pleaseSelectPaymentMethod'), trigger: 'change' }]
      },
      // 用户查询相关
      userSearchForm: {
        zhanghao: ''
      },
      userData: null
    }
  },
  methods: {
    // 搜索礼品卡
    searchCard() {
      if (!this.searchForm.cardNo) {
        this.$message.warning(this.$t('giftCard.inputCardNo'))
        return
      }
      this.$http({
        url: '/giftcard/getByCardNo',
        method: 'get',
        params: {
          'cardNo': this.searchForm.cardNo
        }
      }).then(({data}) => {
        if (data && data.code === 0) {
          this.cardInfo = data.data
          if (this.cardInfo.status !== 0) {
            this.$message.warning(this.$t('giftCardPurchase.cardNotAvailable'))
          }
        } else {
          this.cardInfo = null
          this.$message.error(this.$t('giftCardPurchase.cardNotFound'))
        }
      })
    },
    // 重置搜索
    resetSearch() {
      this.searchForm.cardNo = ''
      this.cardInfo = null
    },
    // 查询用户
    searchUser() {
      if (!this.userSearchForm.zhanghao) {
        this.$message.warning(this.$t('giftCardPurchase.inputUserAccount'))
        return
      }
      const encoded = encodeURIComponent(this.userSearchForm.zhanghao)
      this.$http({
        url: `/yonghu/checkUsername?zhanghao=${encoded}`,
        method: 'get'
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.userData = data.user
          if (!this.userData || this.userData.id === undefined) {
            this.$message.warning(this.$t('giftCardPurchase.userInfoIncomplete'))
          } else {
            this.$message.success(this.$t('giftCardPurchase.userSearchSuccess'))
          }
        } else {
          this.userData = null
          this.$message.error(data.msg || this.$t('giftCardPurchase.userNotExist'))
        }
      }).catch((err) => {
        console.error('查询用户失败:', err)
        this.$message.error(this.$t('giftCardPurchase.userSearchFailed'))
      })
    },
    // 显示购买对话框
    showPurchaseDialog() {
      this.purchaseDialogVisible = true
      this.$nextTick(() => {
        this.$refs['purchaseForm'].resetFields()
      })
    },
    // 购买礼品卡
    purchaseCard() {
      if (!this.userData || !this.userData.id) {
        this.$message.error(this.$t('giftCardPurchase.pleaseSelectUser'))
        return
      }
      this.$refs['purchaseForm'].validate((valid) => {
        if (valid) {
          this.$http({
            url: '/giftcardorder/create',
            method: 'post',
            params: {
              userId: this.userData.id,
              giftcardId: this.cardInfo.id,
              paymentMethod: this.purchaseForm.paymentMethod
            }
          }).then(({data}) => {
            if (data && data.code === 0) {
              // 创建订单成功后，调用支付接口
              this.$http({
                url: '/giftcardorder/pay',
                method: 'post',
                params: {
                  orderNo: data.data.orderNo
                }
              }).then(({data: payData}) => {
                if (payData && payData.code === 0) {
                  this.$message({
                    message: this.$t('giftCardPurchase.purchaseSuccess'),
                    type: 'success',
                    duration: 1500,
                    onClose: () => {
                      this.purchaseDialogVisible = false
                      this.searchCard()
                    }
                  })
                } else {
                  this.$message.error(payData.msg)
                }
              })
            } else {
              this.$message.error(data.msg)
            }
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.main-content {
  padding: 20px;
}

.search-box {
  margin-bottom: 20px;
  padding: 15px;
  background: #f5f7fa;
  border-radius: 4px;
}

.search-box h4 {
  margin: 0 0 15px 0;
  color: #409eff;
  font-weight: 500;
}

.user-info-section {
  margin-bottom: 20px;
}

.user-content {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.info-item {
  display: flex;
  align-items: center;
}

.info-item .label {
  font-weight: 500;
  color: #606266;
  margin-right: 8px;
}

.info-item .value {
  color: #303133;
}

.card-info {
  margin-bottom: 20px;
}

.card-content {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

</style> 
 